<template>
<div style="margin-bottom:1rem;">

<b-row v-if="!event_ended">
 <b-col>  
   <div class="card" style="background-color:transparent;border:none;">
   <div class="card-body" style="padding-top:0">

    <div v-if="signin_redirect">
      <span>
        <b-button variant="success"
          @click="$parent.save_and_signin()">
          Sign in
        </b-button>
      </span>
      <span> You are not signed in. </span>
    </div>
    <div v-if="!signin_redirect && !$parent.registered">
      
      <!-- <div v-if="$parent.event.groups && $parent.event.groups.length > 1">
         Choose ticket tier:
         <b-form-radio-group stacked>-->
           <!-- eslint-disable-next-line vue/valid-v-for vue/no-unused-vars -->
           <!--<b-form-radio v-for="(group,index) in $parent.event.groups"
              v-model="selectedgroup" :value="group.name">
              <b>{{ to_disp_name(group.name) }}</b>
           </b-form-radio>
        </b-form-radio-group>
        <b-collapse v-model="group_error">
           <label class="error">Tier needs to be selected</label>
        </b-collapse>
      </div> -->
      <span>
        <b-button variant="success" @click="openregister">
          Register
        </b-button>
      </span>
      <span> Click to register for this event. </span>
    </div>
    <div v-if="!signin_redirect && $parent.registered">
      <span>
        <b-button variant="outline-danger" @click="deregister">
           Unregister
        </b-button>
      </span>
      <span> You are registered for this event. </span>
    </div>

    </div>
    </div>
  </b-col>
</b-row>

<b-row>
  <b-col style="flex-grow:0;flex-basis:8rem;" v-if="$parent.event.logo" >
      <b-img left fluid style="width:5rem"
         v-if="$parent.event.logo" :src="$parent.event.logo">
      </b-img>
  </b-col>
  <b-col>
      <div v-if="!event_ended"
        class="land_title">
        {{ $parent.event.name }}
      </div>
      <div v-if="event_ended"
        class="land_title land_title_ended">
        {{ $parent.event.name }}
      </div>
      <div v-if="event_ended"
        class="land_title_ended_msg">
        This event has ended
      </div>
      <div class="land_date_time">
        {{ datestring($parent.event) }}
        <add-to-cal
          :title="$parent.event.name"
          :startep="$parent.event.startep"
          :endep="$parent.event.endep"
          :descr="$parent.event.descr"
          :url="get_event_url($parent.event)"
        />
      </div>
  </b-col>
</b-row>

<b-row>
  <b-col>
    <b-card
    >
    <div style="width:100%;text-align:center;">
      <img style="max-width:100%;max-height:25rem;height:auto;vertical-align:middle;" :src="$parent.event.banner">
      </img>
    </div>
    <div class="land_descr">
        <p class="para">{{ $parent.event.descr }}</p>
    </div>
    <div class="float-right" v-if="$parent.event.sponsors && $parent.event.sponsors.filter( sponsor => sponsor.event_sponsor).length">
      <div><center>Sponsors</center></div>
      <div>
         <!-- eslint-disable-next-line vue/require-v-for-key vue/no-unused-vars -->
        <span v-for="(sponsor, index) in $parent.event.sponsors.filter( sponsor => sponsor.event_sponsor)"
            title="" sub-title="" class="sponsorcard">
          <img left fluid :src="sponsor.logo" @click="openbio(sponsor.url)"
               class="sponsorimg"/>
        </span>
      </div>
    </div>
    </b-card>
  </b-col>
</b-row>

<b-row>
  <b-col>
    <div class="card">
     <div class="card-body">
      <div style="text-align:center;">
        <b-link :to="{name:'sessions', params: {}}"
          class="card-title session_hdr">
          Sessions
        </b-link>
      </div>
      <b-row v-for="(session,index) in $parent.event.sessions"
          style="max-height:4rem;"
          class="">
          <b-col sm="2"
            style="text-align:center;">
            <img style="max-width:100%;max-height:3rem;height:auto;vertical-align:middle;padding: 0.2rem 0;" :src="session.banner">
            </img>
          </b-col>
          <b-col sm="3"
            style="">
            {{ep2str(session.startep)}}
          </b-col>
          <b-col sm="7"
            style="">
            {{session.title}}
          </b-col>
        <!-- datestring(session)  speaker in session.speakers -->
      </b-row>
     </div>
    </div>
  </b-col>
</b-row>

<!-- Registration Modal.. -->
  <b-modal id="bv-qn-card" size="lg" hide-footer title="Complete Registration">
     <div style="padding: 1vw 0px">
         <!-- eslint-disable-next-line vue/valid-v-for vue/no-unused-vars -->
          <b-row v-for="(qns,index) in $parent.event.email_reg.ques" >
         <b-col sm="4">
           {{qns.q}}
         </b-col>
         <b-col>
           <b-input size="sm"
             placeholder="Enter Answer"
             v-model="questions[index]"
             value="question"
             required
             >
           </b-input>
         </b-col>
       </b-row>
 
       
          <b-row v-if="this.tkts.length>0" >
           <b-col sm="10" 
           >
             <h5>Select Ticket</h5>
           </b-col>
          </b-row>
       <b-row >
          <b-col sm="10">  
        <b-form-radio
        v-for="(option) in tkts"
        v-model="selectedtkts"
        :key="option.name"
        :value="option"
        name="tickets"
        
      >
        {{ option.name  }} - {{ formatPrice(option.price)}} 
      </b-form-radio>

          </b-col>
       </b-row> 
        

          
         <b-row  v-if="addontkts.length>0">
           <b-col sm="10"
           >
             <h5>Addons</h5>
           </b-col>
        </b-row>
       <b-row >
          <b-col sm="10">
        <b-form-checkbox
        v-for="option in addontkts"
        v-model="selectedaddons"
        :key="option.name"
        :value="option"
        name="addontickets"
      >
        {{ option.name }} - {{ formatPrice(option.price)}} 
        </b-form-checkbox>
          </b-col>
       </b-row> 
       <b-row >
          <b-col sm="10"
          v-if="totaltktprice!='$0.00'"
          >
            Total : {{totaltktprice}}
          </b-col>
       </b-row>
      
       <div class="mt-3">
         <b-button-group class="">
           <b-button class="sm" @click="register" 
            variant="success"
            >
            Register
           </b-button>
         </b-button-group>
         <b-button-group class="float-right">
           <b-button class="sm" @click="$bvModal.hide('bv-qn-card')"
             variant="danger">
             Cancel
           </b-button>
         </b-button-group>
       </div>       
     </div>
  </b-modal>
<!-- Question Modal ends.. -->
</div>
</template>

<script>
import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";
import utils from "../eventutils";
import AddToCal from "../components/AddToCal";

export default {
  name: "reception",
  //props: ['id'],
  data() {
    return {
      authenticated: false,
      bannerProps: { width: 800, height: 400 },
      logoProps: {},
      selectedgroup: "", // need to remove
      selectedgroups: [],
      group_error: false,
      registration_success: false,
      registration_failed: false,
      deregistration_success: false,
      deregistration_failed: false,
      signin_redirect: !vx.user,
      questions: [],
      tkts: [],
      addontkts: [],
      selectedtkts: {},
      selectedaddons: [],
      ticks: [],
    };
  },
  components: {
    AddToCal,
  },
  created() {},

  watch: {
    "$parent.event.id": function (to, from) {
      this.setup();
    },
  },
  methods: {
    datestring: utils.datestring,
    ep2str: utils.ep2str,
    openbio: utils.openbio,
    room_dname: utils.room_dname,
    to_disp_name: function (groupname) {
      var idx = groupname.indexOf("-");
      var subs = groupname.substring(idx + 1);
      if (subs == "allaccess") { return "Free Access"; }
      else { return subs.replaceAll("-", " "); }
    },
    
    register: function () {
      let vue = this;
      let tkts = [vue.selectedtkts, ...(vue.selectedaddons || [])];
      let addontkts = [vue.addontkts];
     
      let reg_qns = [];
      let qns = this.questions;
      if (this.$parent.event.email_reg.ques) {
          this.$parent.event.email_reg.ques.forEach(function (q, index) {
            let ans = { q: q.q, a: qns[index] };
            reg_qns.push(ans);
          });
        }
        let param = {
          subd: window.vx.subd,
          rtag: "register",
          event: {
            id: this.$parent.event.id,
          },
          att: {
            name: vx.user.dname,
            em: "self",
            qustions: reg_qns,
            tickets: tkts,
            access: [],
          },
        };
        console.log('......param', param);
	      
        if(vue.tkts.length===0) {
        param.att.access.push({groupname: this.$parent.event.id+"-freeaccess"})
        }
        param.att.access.push(...vue.selectedgroups);
  
        window.wss_send(vx, "adm_event_add_attendee", param);
        this.$bvModal.hide("bv-qn-card");
    },
    deregister: function () {
      let param = {
        subd: window.vx.subd,
        rtag: "unregister",
        event: {
          id: this.$parent.event.id,
        },
        att: {
          em: "self",
          access: [],
        },
      };
      this.$parent.event.groups.forEach(function (g) {
        param.att.access.push({
          groupname: g.name,
          rem: true,
        });
      });
      window.wss_send(vx, "adm_event_add_attendee", param);
      this.$parent.registered = false;
    },
    get_event_url: function (event) {
      let vue = this;
      let hash = vue.$router.resolve({ name: "event", id: event.id }).href;
      let url;
      if (vx.staging) {
        url = "https://uploadvue-app.staging.vuemix.com";
      } else {
        url = "https://vcafe-app.vuemix.com";
      }
      url += window.location.pathname + hash;
      return url;
    },

    //Open Register Modal
    openregister: function () {
      let vue = this;
      this.$bvModal.show("bv-qn-card");
      vue.fetchtickets();
    },
    fetchtickets: function () {
      let vue = this;
      vue.tkts = [];
      vue.addontkts= [];
      window.wss_send_cb(
        vx,
        "adm_event_get_part",
        {
          event: {
            id: vue.$parent.event.id,
            field: "tickets",
            fid: 1,
          },
        },
        function (msg) {
          console.log(msg);
          vue.tkts = [];

          if (!msg || !msg.data || !msg.data.obj) {
            return;
          }
          let tkt = msg.data.obj[0];

          if (!tkt || !tkt.t) {
            return;
          }
          vue.tkts.id = tkt.id;
          tkt.t.forEach(function (t) {
            if (t.type == "addon" && t.status == "active") {
              vue.addontkts.push(t);
            }
            else if(t.status == "active"){
            vue.tkts.push(t);
            }
          });
          console.log("get_part done-tkts", vue.tkts);
          // -------------------------------
        }
      );
    },
    formatPrice(value) {
      if (!value) {
        return "$0.00";
      }
      return "$" + parseFloat(value).toFixed(2);
    },
    setup: function () {
      let vue = this;
      if (!vue.$parent.event.id) {
        return;
      }
      vue.fetchtickets();
    },
  },

  computed: {
    
    totaltktprice: function () {
      let vue = this;
      let total = 0;
      let ticketitems = [];
      let grouparray = [];

      if(vue.selectedtkts!=undefined && 
         vue.selectedtkts.groups!=undefined && 
         vue.selectedtkts.groups.length>0) {
         vue.selectedtkts.groups.forEach(function(g) {
            grouparray.push({
              "groupname": vue.$parent.event.id+"-"+g, 
              "ticket": vue.selectedtkts.id
            });
         });
      }

      //Calculate Total for Tickets
      total = total+parseFloat(vue.selectedtkts.price);
      ticketitems.push(vue.selectedtkts);
    
      // Calculate Total for addons
      let gpaname = [];
      if (vue.selectedaddons.length > 0) {
          vue.selectedaddons.forEach(function(t) { 
           total = total+parseFloat(t.price);
           t.groups.forEach(function(a) { 
             gpaname.push(a);
             grouparray.push({
               "groupname":vue.$parent.event.id+"-"+a, 
               "ticket" :t.id
             });
           });
           ticketitems.push(t);
        });
      }
     
      vue.selectedgroups = grouparray;
      console.log("Selected Groups",JSON.stringify(vue.selectedgroups));
      //create Ticket Object of Attendee
      vue.tickets = { t: ticketitems, total: total };

      return vue.formatPrice(total);
    },
    event_ended: function () {
      var curtime = new Date().getTime();
      if (curtime > this.$parent.event.endep) {
        return true;
      } else {
        return false;
      }
    },
  },
  beforeDestroy() {
    window.wss_clr_routes(window.vx, "reception");
  },
  mounted() {
    let vue = this;
    window.wss_open(vx, {
      acc: vue.$parent.acc,
      uid: vx.user ? vx.user.id : "not set",
      routes_id: "reception",
      routes: {
        auth_me: function () {},
        opened: function () {},

        adm_event_add_attendee: function (msg) {
          if (msg.rtag == "register") {
            if (msg.data.error) {
              console.log("msg.data.error", msg.data.error);
              vue.registration_failed = true;
              vue.$parent.toast(
                "err",
                "We were unable to register you for this event."
              );
              return;
            }
            vue.registration_success = true;
            vue.$parent.toast(
              "ok",
              "You have successfully registered for the event."
            );

            let event = vue.$parent.event;
            let body = "";
            let subject = vue.$parent.event.email_reg.subject;

            body = "<!DOCTYPE html><html><body>\n";
            if (event.banner) {
              body +=
                '<div><img style="max-height: 8rem; object-fit: contain" src="' +
                event.banner +
                '"></img></div>\n';
            }
            if (event.name) {
              body += "<h2>" + event.name + "</h2>\n";
            }
            body += "<h3>" + utils.datestring(event) + "</h3>\n";
            if (event.email_reg.emailtext) {
              body += "<div>" + event.email_reg.emailtext + "</div>";
            }
            let url = vue.get_event_url(event);
            body +=
              '<div><a style="font-size:2rem;font-weight:600;" href="' +
              url +
              '"> Join Event </a></div>\n';
            body +=
              '<div><a style="margin-top:1rem;font-size:2rem;font-weight:600;" href="' +
              url +
              "cal" +
              '"> Add to Calendar </a></div>\n';
            body += "</body></html>";

            if (!subject) {
              subject = "You have registered for the event " + event.name;
            }
            vue.$parent.registered = true;
            window.wss_send(vx, "adm_event_email_attendee", {
              subd: window.vx.subd,
              event: {
                id: event.id,
              },
              email: {
                em: "self",
                subject: subject,
                body: body,
              },
            });
          } else if (msg.rtag == "unregister") {
            if (msg.data.error) {
              console.log(msg.data.error);
              vue.deregistration_failed = true;
              vue.$parent.toast("err", "Deregistration failed");
              return;
            }
            vue.deregistration_success = true;
            vue.$parent.toast(
              "ok",
              "You have successfully unregistered from the event."
            );
          }
        },
      },
    });
  },
};
</script>

<style lang="scss" scoped>
.rec_deck {
  justify-content: center;
  margin-right: 0;
  margin-left: 0;
}
.rec_card {
  min-width: 20rem;
  max-width: 30rem;
  min-height: 20rem;
  margin-top: 10px;
  margin-bottom: 10px;
}
.land_main {
  padding-top: 10px;
  padding-bottom: 20px;
  position: relative;
}
.land_title {
  font-size: 2.2rem;
  font-weight: 500;
  text-align: left;
  border-bottom: solid black 0.2rem;
  color: black;
  padding-bottom: 0.5rem;
  text-transform: uppercase;
  line-height: 2rem;
}
.land_title_ended {
  text-decoration: line-through red;
  padding-bottom: 0;
}
.land_title_ended_msg {
  color: red;
  font-size: 1rem;
  font-weight: 200;
  text-transform: none;
  padding-bottom: 0.5rem;
}

.land_date_time {
  font-size: 1.1rem;
  font-weight: 500;
  text-align: left;
  color: black;
  padding-bottom: 1rem;
}

.land_descr {
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: 1rem;
  text-align: left;
  color: black;
}
.para {
  white-space: pre-wrap;
}
.land_descr p {
  margin: 0;
}
.speakerimg {
  border-radius: 50%;
  width: 80px;
  height: 80px;
}
.sponsorcard {
  min-width: 10rem;
  max-width: 20rem;
  min-height: 10rem;
  margin: 0 2rem;
  border: none;
}
.session_hdr {
  font-size: 1.5rem;
  text-align: center;
}
.sponsorimg {
  max-width: 4rem;
  max-height: 2rem;
  cursor: pointer;
}

.error {
  color: red;
  padding-top: 10px;
  font-weight: 500;
}
.message {
  font-weight: 500;
  color: red;
  padding-top: 5px;
}
</style>
